var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBleach = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#db011c",
  "data-name": "Group 32871"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32870"
}, /*#__PURE__*/React.createElement("path", {
  d: "M62.257 56.371H17.669l22.294-40.727Zm-41.268-1.967h37.948L39.963 19.742Z",
  "data-name": "Path 19141"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32869"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.258 61.591 40.093-37.939 1.351 1.428L18.609 63.02z",
  "data-name": "Rectangle 26173"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.286 25.059 1.352-1.429 40.107 37.963-1.353 1.429z",
  "data-name": "Rectangle 26174"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M80 80H0V0h80ZM1.311 78.692h77.377V1.311H1.311Z",
  "data-name": "Path 19142"
}))));
export default SvgBleach;